export default {
  computed: {
    hasCover() {
      return !!this.article && !!this.article.cover && !!this.article.cover.images
    },

    article() {
      return this.offer.article
    },

    banner() {
      return this.offer.banners.desktop
    },

    title() {
      if (this.article.title) {
        return this.article.title
      } else if (this.banner.title) {
        return this.banner.title
      }

      return this.offer.name
    },

    intro() {
      if (this.article.intro) {
        return this.article.intro
      } else if (this.banner.description) {
        return this.banner.description
      }

      return this.offer.description
    },
  },
}
